import React from "react";
import { ReactComponent as UpArrow } from '../assets/svgs/up.svg';

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};

function ScrollArrow() {
    return (
        <UpArrow className="scroll-arrow" onClick={() => scrollToTop()} />
    );
}

export default ScrollArrow;